import { useRouter } from "next/router";

export const CALLER_CONTENT_APP_PARAM = "contentapp";
export const useIsCallerContentApp = () => {
    const router = useRouter();

    return router.query.caller === CALLER_CONTENT_APP_PARAM;
};
